











































































































  /* eslint-disable no-console */

  import Vue from 'vue'
  import { Component, Watch } from 'vue-property-decorator'
  import _ from 'lodash'

class SimpleTextFragment {
    id: number
    editionId: number
    editionName: string
    name: string
    confirmed: boolean | null
    matchAuthor: string

  constructor(id: number, editionId: number, editionName: string, name: string, confirmed: boolean | null, matchAuthor: string) {
    this.id = id;
    this.editionId = editionId;
    this.editionName = editionName;
    this.name = name;
    this.confirmed = confirmed;
    this.matchAuthor = matchAuthor;
  }
}

@Component
export default class ImageSelector extends Vue {
    type = 'color'
    side = 'recto'
    institutions: string[] = []
    selectedInstitution = ''
    plates: string[] = []
    selectedPlate = ''
    texts: SimpleTextFragment[] = []
    dialog = false
    imageTypes: string[] = []
    imageSides: string[] = []

    async mounted() {
      try {
          const ref = await this.$com.sqeComms?.getV1ImagedObjectsInstitutions()
          if (ref !== undefined)
            this.institutions = ref.institutions.map(x => x.name) || []
      } catch(err) {
          console.error(err)
      }

    }

    async selectText(text: SimpleTextFragment) {
        const edition = await this.$com.sqeComms?.getV1EditionsEditionId(text.editionId)
        this.dialog = false
        this.$store.commit('selectedEditionSet', edition?.primary)
        this.$store.commit('scroll_idSet', text.editionId)
        this.$store.commit('manuscript_nameSet', text.editionName)
        this.$store.commit('col_idSet', text.id)
        this.$store.commit('colInfoSet', text.name)
    }

    get newType(){
      return this.type
    }

    set newType(val: string) {
        this.$emit('type-select', val)
    }

    get newSide(){
      return this.side
    }
    set newSide(val: string) {
        this.$emit('side-select', val)
        this.$store.commit('imageSideSet', val)
    }

    get newInstitution(){
      return this.selectedInstitution
    }

    set newInstitution(newVal: string) {
      this.selectedInstitution = newVal
        this.loadPlates(newVal)
    }

    async loadPlates(newVal: string){
      try {
        const ref = await this.$com.sqeComms?.getV1ImagedObjectsInstitutionsInstitutionName(newVal)
        console.log(ref)
        if (ref)
          this.plates = [...new Set(ref.institutionalImages.map(x => x.id).filter(x => x !== null))] || []
      } catch(err) {
        console.error(err)
      }
    }

    get newPlate(){
      return this.selectedPlate
    }

    set newPlate(newVal: string) {
      if (newVal !== this.$store.state.image_catalog_id) {
        this.$store.commit('image_catalog_idSet', newVal)
        this.$store.commit('imageInfoSet', newVal)
        this.$store.commit('imageSideSet', this.newSide)
        this.loadImagedObject(newVal)
      }
    }

    async loadImagedObject(newVal: string){
      const images = await this.$com.sqeComms?.getV1ImagedObjectsImagedObjectId(newVal)
      this.imageTypes = images ? images.images.map(x => x.type) : []
      this.imageSides = images ? images.images.map(x => x.side) : []
      const ref = await this.$com.sqeComms?.getV1CatalogueImagedObjectsImagedObjectIdTextFragments(newVal)
      this.texts = ref ? _.uniqWith(ref.matches.map(x => new SimpleTextFragment(x.textFragmentId, x.editionId,
              x.manuscriptName, x.name, x.confirmed ? x.confirmed : null, x.matchAuthor)), _.isEqual) : []
    }

    @Watch('$store.state.image_catalog_id')
    async imageCatalogIdChanged(newVal: string, oldVal: string) {
      if (newVal !== oldVal) {
          let ref = "" + newVal
          let inst = ref.split('-')[0]
          let pl = ref
          if (this.selectedInstitution !== inst){
            this.selectedInstitution = inst
            await this.loadPlates(inst)
          }
          if (this.selectedPlate !== pl){
            this.selectedPlate = pl
            this.side = this.$store.state.imageSide || 'recto'
            await this.loadImagedObject(pl)
          }
      }
    }
}
